<template>
    <div>
      <!-- Estado / Prioridad -->
      <b-row align-v="center" class="d-flex align-items-center">
        <b-col cols="6" class="mb-2">
          <label class="text-capitalize">Estado</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
        </b-col>
        <b-col cols="6" class="mb-2">
          <label class="text-capitalize">Prioridad</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="priorityFilter"
            :options="priorityOptions"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:priorityFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
        </b-col>
      </b-row>

      <!-- Clasificación / PMI -->
      <b-row align-v="center" class="d-flex align-items-center">
        <b-col cols="6" class="mb-2">
          <label class="text-capitalize">Siniestro / Incidente</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="classificationFilter"
            :options="classificationOptions"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:classificationFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
        </b-col>
        <b-col cols="6" class="mb-2">
          <label class="text-capitalize">PMI</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="unitFilter"
            :options="unitOptions"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            :filterable="false"
            :loading="loadingUnits"
            @search="(query, loading) => unitSearch && unitSearch(query, loading)"
            @input="(val) => $emit('update:unitFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
        </b-col>
      </b-row>

      <!-- Proveedor / Mis tickets -->
      <b-row align-v="center" class="d-flex align-items-center">
        <b-col cols="6" class="mb-2">
          <label class="text-capitalize">Proveedor</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="providerFilter"
            :options="providerOptions"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:providerFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
        </b-col>
        <b-col cols="6" class="mb-2">
          <b-form-checkbox
            v-if="$can('assign', 'HelpdeskTicket')"
            :checked="onlyMine"
            switch
            class="mt-2"
            @change="(val) => $emit('update:onlyMine', val)"
          >
            Solo tickets donde participo (creador, administrador o proveedor)
          </b-form-checkbox>
        </b-col>
      </b-row>

      <!-- Fechas -->
      <b-row>
        <b-col cols="6" class="mb-2">
          <label class="text-capitalize">Fecha de creación (desde)</label>
          <div class="input-group">
            <flat-pickr
              :value="startDate"
              class="form-control"
              @input="(val) => $emit('update:startDate', val || null)"
              :config="{ maxDate: new Date(), enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement: 1 }"
            />
            <div class="input-group-append">
              <button @click="$emit('update:startDate', null)" class="btn btn-outline-primary" type="button">x</button>
            </div>
          </div>
        </b-col>
        <b-col cols="6" class="mb-2">
          <label class="text-capitalize">Fecha de creación (hasta)</label>
          <div class="input-group">
            <flat-pickr
              :value="endDate"
              class="form-control"
              @input="(val) => $emit('update:endDate', val || null)"
              :config="{ maxDate: new Date(), enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement: 1 }"
            />
            <div class="input-group-append">
              <button @click="$emit('update:endDate', null)" class="btn btn-outline-primary" type="button">x</button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </template>

  <script>
  import { BRow, BCol, BFormCheckbox } from "bootstrap-vue";
  import vSelect from "vue-select";
  import popperHelper from "@/libs/popper-helper";
  import flatPickr from "vue-flatpickr-component";

  export default {
    components: {
      BRow,
      BCol,
      BFormCheckbox,
      vSelect,
      flatPickr,
    },
    props: {
      statusOptions: { type: Array, default: () => [] },
      statusFilter: { type: Array, default: () => [] },
      priorityOptions: { type: Array, default: () => [] },
      priorityFilter: { type: Array, default: () => [] },
      classificationOptions: { type: Array, default: () => [] },
      classificationFilter: { type: Array, default: () => [] },
      unitOptions: { type: Array, default: () => [] },
      unitSearch: { type: Function, default: null },
      loadingUnits: { type: Boolean, default: false },
      unitFilter: { type: Array, default: () => [] },
      providerOptions: { type: Array, default: () => [] },
      providerFilter: { type: Array, default: () => [] },
      onlyMine: { type: Boolean, default: false },
      startDate: { type: String, default: null },
      endDate: { type: String, default: null },
    },
    setup() {
      return {
        withPopper: popperHelper.withPopper,
      };
    },
  };
  </script>

  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import "@core/scss/vue/libs/vue-flatpicker.scss";
  </style>
